<!-- 
Panel for showing spreadsheet validation errors.
-->
<template>
  <div v-if="show">
    <spreadsheet-upload-error-table :error="error" />
    <our-validation-dialog v-model="showValidationDialog" :state-error="error" />
  </div>
</template>

<script>
import SpreadsheetUploadErrorTable from "@/components/levy-collection-providers/SpreadsheetUploadErrorTable.vue";
import * as mutation from "@/store/system/mutation-types";

export default {
  components: { SpreadsheetUploadErrorTable },
  props: {
    error: {
      default: null,
      type: Object
    }
  },
  computed: {
    show() {
      return this.error && this.error.show;
    },
    isSpreadsheetError() {
      const d = this.error.details.response.data;
      const hasTitle = d && d.title ? true : false;
      return hasTitle && d.title.startsWith("Spreadsheet");
    },
    isValidationError() {
      return this.error.details.response.status == 400;
    }
  },
  watch: {
    show(nowShowing) {
      this.showValidationDialog = !this.isSpreadsheetError && this.isValidationError;
      if (nowShowing && !this.isSpreadsheetError && !this.isValidationError) {
        this.$store.commit(mutation.GLOBAL_ERROR, this.error.details);
      }
    }
  }
};
</script>
